import React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import normalizePostalCode from '@developers/utils/normalizePostalCode';
import Render from '../../../components/Render';

const distances = [
  { distance: 30, display: '30 miles' },
  { distance: 50, display: '50 miles' },
  { distance: 100, display: '100 miles' },
  { distance: 250, display: '250 miles' }
];

export default function PostalCodeForm(props) {

  function updateDistance(e) {
    props.updateDistance(e.target.value);
  }

  function updateZipCode(e) {
    const input = normalizePostalCode(e.target.value);

    props.updateZip(input);
  }

  function searchByZip(e) {
    e.preventDefault();
    props.getServicersByZip();
  }

  function setStylesBasedOnScreenSize(midStyles, smallAndLargeStyles) {
    if (props.screenWidth <= 767 || props.screenWidth >= 1200) {
      return smallAndLargeStyles
    }
    else if (props.screenWidth > 767 && props.screenWidth < 1200) {
      return midStyles
    }
  }

  return (
    <form onSubmit={searchByZip}>
      <div style={setStylesBasedOnScreenSize({marginRight: -10}, {marginRight: -10, width: 135})}className='col-sm-2'>
        <TextField
          style={{ width: '100%', marginBottom: 0}}
          value={props.zip}
          label='Search by Zip'
          variant="standard"
          onChange={updateZipCode}
        />
      </div>
      <div style={setStylesBasedOnScreenSize({marginRight: -55, width: 135}, {marginRight: -55})} className='col-sm-2'>
        <FormControl>
          <InputLabel style={{marginLeft: -12, marginTop: 12}}>Distance</InputLabel>
          <NativeSelect
            onChange={updateDistance}
            value={props.distance}>
            <option value="" />
            {distances.map(item => (
              <option key={item.distance} value={item.distance}>{item.display}</option>
            ))}
          </NativeSelect>
        </FormControl>
      </div>
      <div className='col-sm-2'>
        <Button
          variant="contained"
          color="primary"
          style={setStylesBasedOnScreenSize({marginBottom: 0, marginTop: 15, display: 'inline-block', marginLeft: 30}, 
          { marginBottom: 0, marginTop: 15, display: 'inline-block'})}
          type='submit'
          disabled={!props.zip}
        >
          Search
        </Button>
      </div>
    </form>
  );
}